import React, { useState, useEffect } from "react";
import AsyncCreatableSelect from "react-select/async-creatable";
import { useDispatch } from "react-redux";
import { customReactSelectStyles } from "./medication-select";
import { fetchAllergies } from "../../../../../redux/modules/patient/actions";

const AllergySelect = ({
  type = "Allergy",
  onChange = () => {},
  isRequired = false,
  onNewCreate = () => {},
  error = false,
  value = { value: "", label: "" },
  disabled = false,
  placeholder: placeholderText = "",
  isClearable = true,
  showDropdownIndicator = true,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showError, setShowError] = useState(false);
  let timeoutId;
  const dispatch = useDispatch();
  const fetchAllergy = async (inputValue) => {
    if (!inputValue) {
      return [];
    }
    let results = await dispatch(fetchAllergies(inputValue));
    return results.map((item) => ({
      ...item,
      value: item.id,
      label: item.name,
    }));
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      // Clear the previous timeout, if any
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Set a new timeout
      timeoutId = setTimeout(async () => {
        resolve(await fetchAllergy(inputValue));
      }, 300);
    });

  const handleCreate = (inputValue) => {
    setTimeout(() => {
      const newOption = {
        label: inputValue,
        value: inputValue,
      };
      setSelectedOption(newOption);
      setShowError(isRequired && !newOption.value);
      onChange(newOption);
      onNewCreate(true);
    }, 300);
  };

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setShowError(isRequired && !selectedOption);
    onChange(selectedOption);
    if (selectedOption && selectedOption.value) {
      onNewCreate(false);
    }
  };

  useEffect(() => {
    if (value?.value) {
      setSelectedOption(value);
    } else {
      setSelectedOption(null);
    }
  }, [value]);

  useEffect(() => {
    setShowError(error);
  }, [error]);

  return (
    <div className="w-full col-span-12">
      <div
        className={`relative rounded-[4px] border-[1px]  ${!disabled && isRequired && selectedOption === null ? "bg-blue-100" : "bg-white"
        } ${
          showError ? "border-red-200" : "border-gray-100"
        } px-3 py-3 focus-within:border-REELTeal focus-within:border-[2px]`}
      >
        <div className="">
          <span className="block mb-1 text-gray-900 text-body-xs">
            Allergy {isRequired && <span className="">*</span>}
          </span>
          <AsyncCreatableSelect
            loadOptions={promiseOptions}
            styles={customReactSelectStyles(isRequired, selectedOption)}
            value={selectedOption}
            onChange={handleChange}
            onCreateOption={handleCreate}
            isDisabled={disabled}
            placeholder={placeholderText || `Select ${type}`}
            noOptionsMessage={() => "No allergies found"}
            className=""
            isSearchable={true}
            isClearable={isClearable}
            components={showDropdownIndicator ? undefined : { DropdownIndicator: null, ClearIndicator: null }
            }
          />
        </div>
      </div>
      {showError && (
        <span className="text-red-200 text-xs">Allergy is required</span>
      )}
    </div>
  );
};

export default AllergySelect;
